import React, { useState } from 'react'
import styles from '../../styles/Register.module.scss'
import { useDropzone } from 'react-dropzone'
import { useTranslation } from 'react-i18next'

import {
	Card,
	Button,
	Row,
	Col,
	Alert
} from 'react-bootstrap'

import CardBodyComponent from '../CardBodyComponent'
import WorkExperienceModal from '../WorkExperienceModal'

export default function WorkExperience({ setCurrentStep, experiences, setExperiences, datas, experienceIds, setExperienceIds, inputs, setInputs, setCVData }): JSX.Element {
	// Modal
	const [show, setShow] = useState(false)
	const [showAlert, setShowAlert] = useState(false)
	const { t } = useTranslation()

	const { getRootProps, getInputProps } = useDropzone({
		useFsAccessApi: false,
		accept: {
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
			'application/pdf': ['.pdf'],
			'application/msword': ['.doc']
		},
		maxFiles: 1,
		onDrop: file => {
			if (file.length > 0) {
				setInputs({ ...inputs, cvName: file[0].name })
				setCVData(file[0])
			}
		}
	})

	return (
		<>
			<Row className={styles.row}>
				<Col>
					<h5>
						{t('update_profile.upload_resume')}
						<span className={styles.mandatory}>*</span>
					</h5>
					<div {...getRootProps({ className: 'dropzone' })} className={styles.uploadDropContainer} >
						<input {...getInputProps()} />
						<p>{t('update_profile.drag_and_drop')}</p>
					</div>
					<Card>
						<Card.Header>{t('update_profile.uploaded')}</Card.Header>
						<Card.Body>
							{inputs.cvName === '' ? 'No file uploaded' : inputs.cvName}
						</Card.Body>
					</Card>
				</Col>
			</Row>
			<Row className={styles.row}>
				<Col className='pull-right'>
					<Button
						className='text-white'
						onClick={() => setShow(true)}
					>
						{t('update_profile.add_work_experience')}
					</Button>
				</Col>
			</Row>
			<Card>
				<Card.Header>{t('update_profile.experiences')}</Card.Header>
				{experiences.length === 0 && (
					<Card.Body className={styles.experincesCard}>
						<p className='text-black'>
							{t('profile_new.no_work_experience')}
						</p>
						<p>
							Add work experiences to increase the chances of getting a job
						</p>
					</Card.Body>
				)}
				{experiences.length > 0 && (
					<CardBodyComponent
						experiences={experiences}
						setExperiences={setExperiences}
						experienceIds={experienceIds}
						setExperienceIds={setExperienceIds}
					/>
				)}
			</Card>

			<WorkExperienceModal
				show={show}
				setShow={setShow}
				experiences={experiences}
				setExperiences={setExperiences}
				datas={datas}
			/>

			{showAlert && (
				<Alert
					variant='danger'
					dismissible
					onClose={() => setShowAlert(false)}
					className='mb-4 mt-4'
				>
					Add work experience or upload a resume to proceed
				</Alert>
			)}
			<hr className='mt-4 mb-4' />
			<Row>
				<Col>
					<Button
						variant='link'
						className='text-black'
						onClick={() => setCurrentStep(1)}
					>
						{t('update_profile.back')}
					</Button>
				</Col>
				<Col className='pull-right'>
					<Button
						className='text-white'
						onClick={() => {
							if ((inputs.cvName === '' || inputs.cvName === 'No file selected') && experiences.length === 0) setShowAlert(true)
							else setCurrentStep(3)
						}}
					>
						{t('update_profile.next_step')}
					</Button>
				</Col>
			</Row>

		</>
	)
}
